import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useEffect, useState } from 'react';
import { authAPI } from '../api';

export default function SuperAdminRoute({ children }) {
  const { user } = useAuth();
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const data = await authAPI.me();
        setProfile(data);
      } catch (error) {
        console.error('Erro ao buscar perfil:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchProfile();
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  // Verificar se é SUPER ADMIN (role=admin E companyId=null) OU email específico
  // NÃO pode ser admin de empresa (com companyId)
  const isSuperAdmin = (profile?.email === 'adm@revicont.dev' || 
                        profile?.email === 'adm@rescont.dev' || 
                        (profile?.role === 'admin' && !profile?.companyId)) &&
                       !(profile?.role === 'admin' && profile?.companyId);

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (!isSuperAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}


